module.exports = __webpack_public_path__ + "static/prism_screenshot-60ded2f4d789c4b78f9f05fd1de920fb.gif";